import { render, staticRenderFns } from "./EditDancerModal.vue?vue&type=template&id=de6988c0&scoped=true&"
import script from "./EditDancerModal.vue?vue&type=script&lang=ts&"
export * from "./EditDancerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6988c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6988c0')) {
      api.createRecord('de6988c0', component.options)
    } else {
      api.reload('de6988c0', component.options)
    }
    module.hot.accept("./EditDancerModal.vue?vue&type=template&id=de6988c0&scoped=true&", function () {
      api.rerender('de6988c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/components/EditDancerModal.vue"
export default component.exports